import type { ComponentProps, ReactNode } from 'react';
import { Popover } from 'ui';
import type { QuickViewCardUser } from '../quick-view-user-card';
import { UserPopoverContent, type UserPopoverWithQuery } from './user-popover-content';

export type UserPopoverUserProperties =
  | {
      user: QuickViewCardUser;
    }
  | UserPopoverWithQuery;

type P = {
  children: ReactNode;
  popoverProps?: Omit<ComponentProps<typeof Popover>, 'content'>;
} & UserPopoverUserProperties;

// TODO: looks like this component should be in ui
const UserPopover = ({ children, popoverProps, ...rest }: P) => (
  <Popover
    arrow={false}
    classNames={{ container: 'user-popover' }}
    content={<UserPopoverContent {...rest} />}
    {...popoverProps}
  >
    {children}
  </Popover>
);

export default UserPopover;
